import { Component, Input, AfterViewInit, NgZone } from '@angular/core';
import { ActivatedRoute, Router, NavigationExtras, Params } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { PagesService } from '../../services/pages.service';
import { MenuService } from '../../services/menu.service';
import { MessagesService } from '../../services/messages.service';
import * as firebase from 'firebase/app';
import 'firebase/auth';
import { ProgramsService } from '../../services/programs.service';
import { NavController, ActionSheetController, AlertController, ToastController, PopoverController, Platform } from '@ionic/angular';
import { ThemeService } from '../../services/theme.service';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { FormService } from '../../services/form.service';
import { MemberService } from '../../services/member.service';
import { ModalController } from '@ionic/angular';
import { ModalPage } from '../../modals/modal/modal.page';
import { Zoom } from '@ionic-native/zoom/ngx';
import { NetworkInfoComponent } from '../network-info/network-info.component';
import { ChatComponent } from '../chat/chat.component';
import { ChannelInt } from '../../channels/channels.component';

@Component({
  selector: 'app-pages',
  templateUrl: './pages.component.html',
  styleUrls: ['./pages.component.scss'],
})
export class PagesComponent implements AfterViewInit {
  // Dynamic parameters for this component's route: /example-params/:first/:second
  routeParams: Params;

  // Query parameters found in the URL: /example-params/one/two?query1=one&query2=two
  queryParams: Params;
  formResults: any;
  formName: string;
  alias: string;
  pageContent: any;
  channelId: string;
  @Input() formFieldGroup: string;
  @Input() class: string;
  @Input() component: ChatComponent;
  
  public baseUrl: string;
  message: any;
  title: string;
  introtext: string;
  menuType: string;
  data: any;
  note: string;
  articleId: string;
  pageContentList: any;
  pageType: string;
  icon: string;
  menuProperties: any;
  channels: any;
  channelList: any;
  networks: any;
  networkList: any;
  siteApiKey: string;

  id: string;
  description: string;
  dates: string;
  credits: string;
  courseMaterialsList: any;
  dashboardWidgets: any;
  pleaseSignInMessage: string;
  currentDate: Date;
  tileOverlayWidth: number;
  tileOverlayHeight: number;

  // User Info
  uid: string;
  profileData: any;
  name: string;
  phone: string;

  memberList: any;

  //ZOOM
  // Login variables
  userName = '';
  password = '';
  loggedIn = false;
  API_KEY: string;
  API_SECRET: string;
  meetingNumber: string;
  meetingPassword: string;
  displayName: string;
  SDK_KEY = 'gycPK5iW83gLKv3ei2mx3mKcrIYzSuDoHGgs';
  SDK_SECRET = '3VkzRy38fJAw7zq5gyfw7D4F8Ly5HJeXQhVE';

  // NEWS
  slideOpts = {
    initialSlide: 1,
    speed: 400
  };

  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
    private router: Router,
    public activatedRoute: ActivatedRoute,
    private pageService: PagesService,
    private menuService: MenuService,
    public messageService: MessagesService,
    private networkService: ProgramsService,
    public navCtrl: NavController,
    private themeService: ThemeService,
    public fontLibrary: FaIconLibrary,
    private formService: FormService,
    private memberService: MemberService,
    public modalController: ModalController,
    public actionSheetController: ActionSheetController,
    public alertController: AlertController,
    private toastCtrl: ToastController,
    public zoomService: Zoom,
    public popoverController: PopoverController,
    private platform: Platform,
    private ngZone: NgZone,
    private channelService: ProgramsService
    ) {

      // this.activatedRoute.queryParams.subscribe( params => {
      //   this.queryParams = params;
      // });

      // if (this.route.snapshot.paramMap.get('pagetype') !== null) {
      //   this.pageType = this.route.snapshot.paramMap.get('pagetype');
      // }
      
      this.fontLibrary.addIconPacks(fas);

      this.themeService.getAuthorizationSettings().once('value', snapshot => {
        this.pleaseSignInMessage = snapshot.val().please_sign_in;
      });
 
      firebase.auth().onAuthStateChanged((user) => {
        if (user) {
          this.uid = user.uid;
          this.messageService.getMessage().on('value', messageSnapshot => {
            this.message = [];
            messageSnapshot.forEach(snap => {
              if (snap.val().active === 'true') {
                this.message.push({
                  title: snap.val().title,
                  message: snap.val().message,
                  date: snap.val().date,
                  messageType: snap.val().message_type,
                  user: snap.val().user
                });
              }
            });
          });
          
          this.authService.getUserProfile(this.uid).on('value', snapshot => {
            if (snapshot.val() != null) {
              this.name = snapshot.val().name;
            }
            
            // this.profileData = [];
            // snapshot.forEach(snap => {
            //   this.profileData.push({
            //     name: snap.val().name,

            //   })
            // })
          });
        } else {
          this.router.navigateByUrl('sign-in');
        }
      });

      this.menuService.getPages().on('value', snapshot => {
        this.dashboardWidgets = [];
        snapshot.forEach(snap => {
          if (snap.val().menutype === 'dashboard' && snap.val().published === 1) {
            this.dashboardWidgets.push({
              title: snap.val().title,
              note: snap.val().note,
              published: snap.val().published,
              url: '/page/' + this.getMenuID(snap.val().link),
              featured: snap.val().featured,
              menutype: snap.val().menutype,
              id: snap.val().id,
              parent_id: snap.val().parent_id,
              level: snap.val().level,
              icon: snap.val().note
            });
            return false;
          }
        });
      });

      this.articleId = this.route.snapshot.paramMap.get('articleId');
      this.pageType = this.route.snapshot.paramMap.get('pagetype');

      this.pageService.getPages().once('value', snapshot => {
        this.pageContentList = [];
        snapshot.forEach(snap => {
          if (snap.val().id.toString() === this.articleId && snap.val().state === 1) {
            this.pageContentList.push({
              id: snap.val().id,
              title: snap.val().title,
              fulltext: snap.val().fulltext,
              introtext: snap.val().introtext,
              pageType: this.getPageType(snap.val().note),
              form: this.getForm(snap.val().note)
            });
          }
        });
      });

      this.memberService.getMembers().on('value', snapshot => {
        this.memberList = [];
        snapshot.forEach(snap => {
          this.memberList.push({
            name: snap.val().name,
            email: snap.val().email,
            username: snap.val().username,
            uid: snap.key
          });
        });
      });

      const options = {
        no_driving_mode: true,
        no_invite: true,
        no_meeting_end_message: true,
        no_titlebar: false,
        no_bottom_toolbar: false,
        no_dial_in_via_phone: true,
        no_dial_out_to_phone: true,
        no_disconnect_audio: true,
        no_share: true,
        no_audio: true,
        no_video: true,
        no_meeting_error_message: true
      };
      // if (this.platform.is('ios') || this.platform.is('android')) {
      //   this.zoomService.joinMeeting(this.meetingNumber, this.meetingPassword, this.displayName, options)
      //   .then((success: any) => console.log(success))
      //   .catch((error: any) => console.log(error));
      // }

      // this.pageService.getCourseMaterials().once('value', courseSnapshot => {
      //   this.courseMaterialsList = [];
      //   console.log('menu id', typeof(menuSnapshot.val().id));
      //   courseSnapshot.forEach(snap => {
      //     if (snap.val().course === menuSnapshot.val().id.toString()) {
      //       this.courseMaterialsList.push({
      //         title: snap.val().title,
      //         link: snap.val().link
      //       });
      //     }
      //     console.log('course id', typeof(snap.val().course));
      //   });
      // });
      
      

    }

  ngAfterViewInit() {
    this.activatedRoute.queryParams.subscribe( params => {
      this.queryParams = params;
    });

    if (this.route.snapshot.paramMap.get('pagetype') !== null) {
      this.pageType = this.route.snapshot.paramMap.get('pagetype');
    }
    
    this.channelList = [];
    this.channelService.getChannelsApi()
    .subscribe(data => {
      let itemList = [];
      itemList = Object.values(data);
      itemList.forEach(res => {
        this.channelList.push({
          title: res.title,
          channelDescription: res.channel_description,
          channelImage: res.channel_image,
          elearningChannel: res.elearning_channel,
          id: res.id,
          randomize: res.randomize,
          ordering: res.ordering,
          baseUrl: res.base_url,
          programs: res.programs,
          state: res.state,
          subscriptionRequired: res.subscription_required,
          broadcastType: res.broadcast_type
        });
      });
    });
  }

  getRouteParams() {

    // Route parameters
    this.activatedRoute.params.subscribe( params => {
        this.routeParams = params;
    });

    // URL query parameters
    this.activatedRoute.queryParams.subscribe( params => {
        this.queryParams = params;

        this.pageContentList.pagetype = 'dashboard';
    });
  }

  goToCard() {
    this.router.navigate(['card-form']);
  }

  async presentPopover(networkName, networkDescription, networkID) {
    const popover = await this.popoverController.create({
      component: NetworkInfoComponent,
      translucent: true,
      componentProps: {
        networkID: networkID,
        networkName: networkName,
        networkDescription: networkDescription
      }
    });
    return await popover.present();
  }

  login() {
    this.zoomService.login(this.userName, this.password)
      .then((success) => {
        this.presentToast(success.message);
        this.loggedIn = true;
        this.userName = '';
        this.password = '';
      }).catch((error) => {
        this.presentToast(error.message);
      });
  }

  async getDescription(networkName, networkDescription, networkID) {
    const alert = await this.alertController.create({
      header: networkName,
      subHeader: 'Description',
      message: networkDescription,
      buttons: [
        {
          text: 'X',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
          }
        }, {
          text: 'Subscribe',
          handler: () => {
            
          }
        }
      ]
    });

    await alert.present();
  }

  async presentActionSheet() {
    const actionSheet = await this.actionSheetController.create({
      header: 'Albums',
      buttons: [{
        text: 'Delete',
        role: 'destructive',
        icon: 'trash',
        handler: () => {

        }
      }, {
        text: 'Share',
        icon: 'share',
        handler: () => {

        }
      }, {
        text: 'Play (open modal)',
        icon: 'arrow-dropright-circle',
        handler: () => {

        }
      }, {
        text: 'Favorite',
        icon: 'heart',
        handler: () => {

        }
      }, {
        text: 'Cancel',
        icon: 'close',
        role: 'cancel',
        handler: () => {

        }
      }]
    });
    await actionSheet.present();
  }

  async editProfile(profileData) {
    const modal = await this.modalController.create({
      component: ModalPage,
      componentProps: profileData
    });
    return await modal.present();
  }

  receiveFormResults($event, formName) {
    this.formResults = $event;
    this.currentDate = new Date();
    this.formService.saveFormResults(this.formResults, formName, this.uid, this.currentDate);
  }

  logout() {
    this.authService.logoutUser();
    // this.authService.logoutJoomlaUser().subscribe((data) => {
    // });
    localStorage.setItem('session_id', null);
    localStorage.setItem('user', null);
    this.profileData = null;
    this.router.navigateByUrl('/sign-in');
    this.name = null;
  }

  viewMaterials(link) {
    const courseMaterials = {
      link: link
    };

    const navigationExtras: NavigationExtras = {
      state: {
        materials: courseMaterials
      }
    };
    this.router.navigate(['course-materials'], navigationExtras);
  }

  openDetailsWithState(id, title, description, programs, elearningChannel, broadcastType) {
    const channelDetails = {
      id: id,
      title: title,
      description: description,
      programs: programs,
      elearningChannel: elearningChannel,
      broadcastType: broadcastType
    };
    const navigationExtras: NavigationExtras = {
      state: {
        channel: channelDetails
      }
    };
    this.router.navigate(['media-player'], navigationExtras);
  }

  getChannels(networkId, channels) {
    localStorage.setItem('networkId', networkId);
    localStorage.setItem('channels', channels);
    const channelDetails = {
      networkId: networkId,
      channels: channels
    };
    const navigationExtras: NavigationExtras = {
      state: {
        channel: channelDetails
      }
    };
    this.router.navigate(['channels'], navigationExtras);
  }

  getPageType(menuPropList) {
    const menuProps = menuPropList.split(',');
    for (let i = 0; i < menuProps.length; i++) {
      if (menuProps[i].match(/pagetype/g)) {
        const menuProp = menuProps[i].split(':');
        return menuProp[1];
      }
    }
  }

  getDashIcon(menuPropList) {
    const menuProps = menuPropList.split(',');
    for (let i = 0; i < menuProps.length; i++) {
      if (menuProps[i].match(/icon/g)) {
        const menuProp = menuProps[i].split(':');
        return menuProp[1];
      }
    }
  }

  getForm(menuPropList) {
    const menuProps = menuPropList.split(',');
    for (let i = 0; i < menuProps.length; i++) {
      if (menuProps[i].match(/form/g)) {
        const menuProp = menuProps[i].split(':');
        return menuProp[1];
      }
    }
  }

  getMenuID(link) {
    const linkParts = link.split('&');
    for (let i = 0; i < linkParts.length; i++) {
      const articleIdKey = linkParts[i].match(/id/g);
      if (articleIdKey) {
        const articleId = linkParts[i].split('=');
        return articleId[1];
      }
    }
  }

  async presentToast(text) {
    const toast = await this.toastCtrl.create({
      message: text,
      duration: 3000,
      position: 'bottom'
    });
    toast.present();
  }

  /**
   * Log user out.
   */
  logoutZoom() {
    this.zoomService.logout().then((success) => {
      this.presentToast(success.message);
      this.loggedIn = false;
    }).catch((error) => {
      this.presentToast(error.message);
    });
  }

  /**
   * Join a meeting.
   */
  joinMeeting() {
    const options = {
      no_driving_mode: true,
      no_invite: true,
      no_meeting_end_message: true,
      no_titlebar: false,
      no_bottom_toolbar: false,
      no_dial_in_via_phone: true,
      no_dial_out_to_phone: true,
      no_disconnect_audio: true,
      no_share: true,
      no_audio: true,
      no_video: true,
      no_meeting_error_message: true
    };
    this.zoomService.joinMeeting(this.meetingNumber, this.meetingPassword, this.displayName, options)
        .then((success) => {
          this.presentToast(success);
          this.meetingNumber = null;
          this.meetingPassword = null;
        }).catch((error) => {
          this.presentToast(error);
    });
  }

  /**
   * Start an existing meeting.
   */
  startMeeting() {
    // Prepare meeting options
    const options = {};
    // Call start meeting method.
    this.zoomService.startMeeting(this.meetingNumber, options).then((success) => {
      this.presentToast(success);
      this.meetingNumber = null;
      this.meetingPassword = null;
    }).catch((error) => {
      this.presentToast(error);
    });
  }

  /**
   * Start an instant meeting.
   */
  startInstantMeeting() {
    // Prepare meeting options
    const options = {};
    // Call start instant meeting method.
    this.zoomService.startInstantMeeting(options).then((success) => {
      this.presentToast(success);
    }).catch((error) => {
      this.presentToast(error);
    });
  }

  isLoggedIn() {
    this.zoomService.isLoggedIn().then((success) => {
      this.presentToast(success);
      if (success === true) {
        this.loggedIn = true;
      } else {
        this.loggedIn = false;
      }
    }).catch((error) => {
      this.presentToast(error);
    });
  }

  // Channels
  async getChannelDescription(title, channelDescription) {
    const alert = await this.alertController.create({
      header: title,
      subHeader: 'Description',
      message: channelDescription,
      buttons: ['X']
    });

    await alert.present();
  }

  shuffle(array) {
    let currentIndex = array.length, temporaryValue, randomIndex;
  
    // While there remain elements to shuffle...
    while (0 !== currentIndex) {
  
      // Pick a remaining element...
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;
  
      // And swap it with the current element.
      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }
  
    return array;
  }

  openChannelDetailsWithState(id, title, description, programs, elearningChannel, baseUrl, usergroup, broadcastType, randomize, channelImage) {
    const channelDetails = {
      id: id,
      title: title,
      description: description,
      programs: programs,
      elearningChannel: elearningChannel,
      baseUrl: baseUrl,
      usergroup: usergroup,
      broadcastType: broadcastType,
      randomize: randomize,
      channelImage: channelImage
    };
    const navigationExtras: NavigationExtras = {
      state: {
        channel: channelDetails
      }
    };
    // this.router.navigate(['media-player'], navigationExtras);
    this.router.navigate(['player'], navigationExtras);
  }

  goTocard() {
    this.router.navigate(['card-form']);
  }

  // getProfile() {
  //   this.authService.getUserProfile().subscribe(response => {
  //     this.profileData = {
  //       name: response.name,
  //       username: response.username,
  //       fields: response.fields
  //     };
  //   });
  // }


}
